/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Due_Payments_PayInputs */

const en_due_payments_pay = /** @type {(inputs: Due_Payments_PayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay`)
};

const pl_due_payments_pay = /** @type {(inputs: Due_Payments_PayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapłać`)
};

/**
* | output |
* | --- |
* | "Pay" |
*
* @param {Due_Payments_PayInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const due_payments_pay = /** @type {((inputs?: Due_Payments_PayInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Due_Payments_PayInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_due_payments_pay(inputs)
	return en_due_payments_pay(inputs)
});